import styled from 'styled-components';
import { palette } from 'styled-theme';

export const LeftSidebarWrapper = styled.div`
  position: fixed;
  left: 0;
  top: 0; /* Go all the way to the top */
  height: 100vh;
  width: 46px; /* Reduced width to 46px */
  background: ${palette('secondary', 0)};
  z-index: 1001; /* Higher than topbar */
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0; /* No padding for perfect alignment */
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);

  .nav-items {
    display: flex;
    flex-direction: column;
    gap: 4px; /* Reduced gap to 4px */
    width: 100%;
    align-items: center;
  }

  .nav-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px; /* 38px width to align with topbar content height */
    height: 38px; /* 38px height to align with topbar content height */
    margin: 2px; /* 2px margin on all sides */
    border-radius: 6px;
    transition: all 0.3s ease;
    cursor: pointer;
    text-decoration: none;
    color: inherit;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      transform: translateX(2px);
    }

    &.clickable {
      cursor: pointer;
    }
  }

  .nav-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: ${palette('grayscale', 6)};
    transition: all 0.3s ease;

    &.active {
      color: ${palette('primary', 0)};
      background: rgba(24, 144, 255, 0.1);
      border-radius: 6px;
    }

    &:hover {
      color: ${palette('primary', 0)};
    }
  }

  /* Mobile uses the full-screen MobileMenu instead */
  @media (max-width: 768px) {
    display: none;
  }
`;
